/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const RecordFormPage = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [userId, setUserId] = useState('');
  const [quizId, setQuizId] = useState('');
  const [score, setScore] = useState('');

  useEffect(() => {
    axios.get('/api/users')
      .then(res => setUsers(res.data))
      .catch(console.error);
    axios.get('/api/quizzes')
      .then(res => setQuizzes(res.data))
      .catch(console.error);

    if (isEdit) {
      axios.get(`/api/records/${id}`)
        .then(res => {
          setUserId(res.data.userId);
          setQuizId(res.data.quizId);
          setScore(res.data.score);
        })
        .catch(console.error);
    }
  }, [id, isEdit]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const payload = { userId, quizId, score: parseFloat(score) };
      if (isEdit) {
        await axios.put(`/api/records/${id}`, payload);
      } else {
        await axios.post('/api/records', payload);
      }
      navigate('/dashboard/admin/records');
    } catch (err) {
      alert(err.response?.data?.error || 'Error saving record');
    }
  };

  return (
    <div className="p-6 max-w-md">
      <h1 className="text-2xl mb-4">{isEdit ? 'Edit' : 'New'} Record</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">User</label>
          <select
            className="w-full border p-2"
            value={userId}
            onChange={e => setUserId(e.target.value)}
            required
          >
            <option value="">Select user</option>
            {users.map(u => (
              <option key={u.id} value={u.id}>{u.email}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block mb-1">Quiz</label>
          <select
            className="w-full border p-2"
            value={quizId}
            onChange={e => setQuizId(e.target.value)}
            required
          >
            <option value="">Select quiz</option>
            {quizzes.map(q => (
              <option key={q.id} value={q.id}>{q.title}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block mb-1">Score</label>
          <input
            type="number"
            step="0.1"
            className="w-full border p-2"
            value={score}
            onChange={e => setScore(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          {isEdit ? 'Update' : 'Create'}
        </button>
      </form>
    </div>
  );
};

export default RecordFormPage;
